import ChatContainer from "./chat-container";
import ChatInput from "./chat-input";
import Contacts from "./contact-list";
import ChatbotPopup from "./chatbot-popup";
import Welcome from "./welcome-text";

export default { ChatContainer, ChatbotPopup, ChatInput, Contacts, Welcome };
